import client from '../axios';
import { POST_BRANCH, PUT_BRANCH, GET_BRANCH_DETAIL, GET_BRANCH_STATUS, GET_BRANCH_ISSUE, POST_BRANCH_ISSUE, PUT_BRANCH_ISSUE, DELETE_BRANCH_ISSUE, GET_BRANCH_STAFF_JOB, POST_BRANCH_STAFF_JOB,GET_BRANCH_JOB_STAFF_LIST, DELETE_BRANCH_STAFF_JOB, GET_BRANCH_STAFF, PUT_BRANCH_STAFF, POST_BRANCH_STAFF, GET_BRANCH_MANAGE_INFOSCHOOL, POST_MEMBER_RECESS_COMMENT, DELETE_BRANCH_STAFF, GET_BRANCH_CLOSING_REPORT_DETAIL, GET_BRANCH_CLOSING_REPORT_LIST, GET_BRANCH_SCHOOL_CHARGE, GET_BRANCH_SCHOOL_CHARGE_DETAIL, POST_SCHOOLCLOSINGREPORT_DETAIL, POST_BRANCH_CLOSING_REPORT_PER_UPDATE, POST_BRANCH_CLOSING_REPORT_UPDATE, PUT_MEMBER_RECESS_COMMENT } from './endpoint';
import { postTransientStorageSchoolClosingReportDetail } from './school-closing-report';

//지사 등록
export const postBranchAPI = (data) => {
  return client.post(POST_BRANCH, data);
  // return client.post(POST_HQ_BRANCH_MANAGE_ADDBRANCH, data);
};

// 지사 상세
export const getBranchAPI = (idx) => {
  return client.get(GET_BRANCH_DETAIL.replace(':branch_idx', idx));
};

// 지사 수정
export const putBranchAPI = (idx, data) => {
  return client.put(PUT_BRANCH.replace(':branch_idx', idx), data);
};

// 지사 삭제
// export const deleteBranchAPI = (data) => {
//   return client.delete(DELETE_BRANCH)
// }

// 지사현황 상세
export const getBranchStatusAPI = (idx) => {
  return client.get(GET_BRANCH_STATUS.replace(':branch_idx', idx));
};

//지사 이슈 추가
export const postBranchIssueAPI = (data) => {
  console.log(data);
  return client.post(POST_BRANCH_ISSUE, data);
};

// 지사이슈 수정
export const putBranchIssueAPI = (idx, data) => {
  console.log(idx, data);
  return client.put(PUT_BRANCH_ISSUE.replace(':issue_idx', idx), data);
};

// 지사이슈 삭제
export const deleteBranchIssueAPI = (idx) => {
  console.log(idx);
  return client.delete(DELETE_BRANCH_ISSUE.replace(':issue_idx', idx));
};

// 지사 이슈 목록
export const getBranchIssueAPI = (idx) => {
  return client.get(GET_BRANCH_ISSUE + '?branch_idx=' + idx);
};

// 지사 업무분장 목록
export const getBranchStaffJobListAPI = (idx) => {
  return client.get(GET_BRANCH_STAFF_JOB + '?branch_idx=' + idx);
};

// 지사 업무분장 등록
export const postBranchStaffJobAPI = (data) => {
  return client.post(POST_BRANCH_STAFF_JOB, data);
};
// 지사 업무분장 등록
export const getBranchJobStaffListAPI = (data) => {
  return client.get(GET_BRANCH_JOB_STAFF_LIST, data);
};
// 지사 업무분장 삭제
export const deleteBranchStaffJobAPI = (branch_idx, roll_no, branch_staff_idx) => {
  const url = DELETE_BRANCH_STAFF_JOB.replace(':branch_idx/:roll_no/:branch_staff_idx', `${branch_idx}/${roll_no}/${branch_staff_idx}`);
  return client.delete(url);
};

// 지사 직원 목록
export const getBranchStaffListAPI = (idx) => {
  return client.get(GET_BRANCH_STAFF + '?branch_idx=' + idx);
};

// 지사 직원 수정
export const putBranchStaffAPI = (data) => {
  const url = PUT_BRANCH_STAFF.replace(':branch_idx', data.branch_idx);
  return client.put(url, data);
};

export const deleteBranchStaffAPI = (data) => {
  return client.delete(DELETE_BRANCH_STAFF, { data });
};

// 지사 직원 등록
export const postBranchStaffAPI = (data) => {
  const url = POST_BRANCH_STAFF.replace(':branch_idx', data.branch_idx);
  return client.post(url, data);
};

export const getBranchManageInfoSchoolAPI = (data) => {
  const url = GET_BRANCH_MANAGE_INFOSCHOOL.replace(':branch_idx', data.branch_idx);
  return client.get(url.concat(`?yyyymm=${data.yyyymm}`));
};

// 지사 코멘트 신청 반려
export const putBranchRegressCommentAPI = ({ data }) => {
  return client.put(PUT_MEMBER_RECESS_COMMENT, data);
};

// 지사 마감보고서 상세
export const getBranchClosingReportDetail = (params) => {
  const url = `${GET_BRANCH_CLOSING_REPORT_DETAIL}/${params?.yyyymm}/${params?.branchIdx}/${params?.reportIdx}`;
  return client.get(url);
};

export const getBranchClosingReportList = (params) => {
  const url = `${GET_BRANCH_CLOSING_REPORT_LIST}/${params?.yyyy}/${params?.branch_idx}`;
  return client.get(url);
};

// 지사 실적 마감보고서 수정
export const postBranchClosingReportPerUpdate = (data) => {
  return client.post(POST_BRANCH_CLOSING_REPORT_PER_UPDATE, data);
};

// 지사 마감보고서 수정 - 임시저장
export const postTransientStorageBranchClosingReportUpdate = (data) => {
  const value = { ...data, submit_status: 0 };
  return client.post(POST_BRANCH_CLOSING_REPORT_UPDATE, value);
};

// 지사 마감보고서 수정 - 제출
export const postBranchClosingReportUpdate = (data) => {
  const value = { ...data, submit_status: 1 };
  return client.post(POST_BRANCH_CLOSING_REPORT_UPDATE, value);
};

// 지사 관리 교육원 수수료 현황
export const getBranchSchoolChargeList = (params, branch_idx) => {
  return client.get(GET_BRANCH_SCHOOL_CHARGE.replace(':branch_idx', branch_idx), { params });
};

// 지사 관리 교육원 수수료 현황 상세
export const getBranchSchoolChargeDetailList = (data) => {
  return client.get(GET_BRANCH_SCHOOL_CHARGE_DETAIL.replace(':branch_idx', data.branch_idx).replace(':school_idx', data.school_idx), { params: { yyyymm: data.yyyymm } });
};
